import CONFIG from './env'

export * from './env'
export default CONFIG
